import { render, staticRenderFns } from "./jinchu.vue?vue&type=template&id=597c1b5b&scoped=true&"
import script from "./jinchu.vue?vue&type=script&lang=js&"
export * from "./jinchu.vue?vue&type=script&lang=js&"
import style0 from "./jinchu.vue?vue&type=style&index=0&id=597c1b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c1b5b",
  null
  
)

export default component.exports